/**
 * Native free-gift-with-purchase (replaces the BOGOS app).
 *
 * Offer rules (mirrors the landing-page buy box):
 *   - Oil bought as a subscription (any bottle count)  -> free soap
 *   - 3-Bottle variant in cart (sub or one-time)       -> free Kansa Wand
 *
 * How it works:
 *   - This script manages cart contents: it auto-adds/removes the gift lines,
 *     tagged with a `_kb_free_gift` line property, and keeps them in sync with
 *     the qualifying items ("click-proof").
 *   - The soap (handle "mystery-gift") is priced $12. The "Free Gift" BXGY
 *     discount (buys: oil as a subscription) makes it free, so Shopify decides
 *     at checkout who earns it. A BXGY discount never adds the free item, so
 *     this script still adds it.
 *   - The Kansa gift is a hidden $0 twin of the $49 catalog wand, not a BXGY
 *     discount: one oil line unlocks only ONE BXGY discount, and Shopify picks
 *     the bigger one. With the real wand discounted, the soap is charged $12.
 *   - The "Buy 3 - Get a Kansa Wand" BXGY discount stays active for a customer
 *     who adds the real wand by hand to a 3-Bottle cart. In a subscription
 *     cart that same conflict charges the soap.
 *   - Gift lines render with a strikethrough (compare-at) + FREE and no
 *     quantity controls (see cart-drawer.liquid / main-cart-items.liquid).
 */
(function () {
  var OIL_PRODUCT_ID = 6746383515966; // Ayurvedic Vitamin C Face Oil (sold with selling plans)
  var SUB_PRODUCT_ID = 11908932763966; // Ayurvedic Vitamin C Face Oil Subscription
  var THREE_PACK_VARIANT_ID = 52676764369214; // "3 Bottles" variant of the oil
  var REAL_KANSA_VARIANT_ID = 48957026861374; // catalog Kansa Wand ($49)

  var GIFT_PROP = '_kb_free_gift';
  var GIFTS = [
    {
      // Handmade Citrus Soap ($12, made free by the "Free Gift" discount)
      variantId: 51771399897406,
      qualifies: function (items) {
        return items.some(function (item) {
          if (item.properties && item.properties[GIFT_PROP]) return false;
          if (item.product_id === SUB_PRODUCT_ID) return true;
          return item.product_id === OIL_PRODUCT_ID && !!item.selling_plan_allocation;
        });
      },
    },
    {
      // Kansa Wand gift ($0 twin, compare-at $49) — product "🎁 Kansa Wand (FREE)",
      // owned by us (the old BOGOS clone was deleted when BOGOS offers were removed)
      variantId: 53855776571710,
      qualifies: function (items) {
        return items.some(function (item) {
          return item.variant_id === THREE_PACK_VARIANT_ID;
        });
      },
      // Also satisfied by a REAL Kansa line the customer added that ended up
      // free via the "Buy 3 - Get a Kansa Wand" BXGY discount (one-time 3-packs).
      isSatisfiedBy: function (item) {
        return item.variant_id === REAL_KANSA_VARIANT_ID && item.final_line_price === 0;
      },
    },
  ];

  var busy = false;
  var rerunRequested = false;

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json();
    });
  }

  function postJSON(url, body) {
    return fetchJSON(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }

  // Computes the add/change calls needed to bring gift lines in line with the rules.
  function planChanges(cart) {
    var items = cart.items || [];
    var changes = [];

    GIFTS.forEach(function (gift) {
      var expected = gift.qualifies(items);
      // The gift variants aren't legitimately purchasable, so every line of a
      // gift variant is managed by this script — property-tagged or not.
      var giftLines = items.filter(function (item) {
        return item.variant_id === gift.variantId;
      });
      var present =
        giftLines.length > 0 ||
        items.some(function (item) {
          return gift.isSatisfiedBy ? gift.isSatisfiedBy(item) : false;
        });

      if (expected && !present) {
        changes.push({ type: 'add', variantId: gift.variantId });
      } else if (!expected) {
        giftLines.forEach(function (line) {
          changes.push({ type: 'change', key: line.key, quantity: 0 });
        });
      } else {
        // Earned: keep exactly one gift line at qty 1, drop any duplicates.
        giftLines.forEach(function (line, index) {
          var wanted = index === 0 ? 1 : 0;
          if (line.quantity !== wanted) changes.push({ type: 'change', key: line.key, quantity: wanted });
        });
      }
    });

    return changes;
  }

  function applyChanges(changes) {
    return changes.reduce(function (chain, change) {
      return chain.then(function () {
        if (change.type === 'add') {
          var properties = {};
          properties[GIFT_PROP] = '1';
          return postJSON((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
            items: [{ id: change.variantId, quantity: 1, properties: properties }],
          });
        }
        return postJSON((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
          id: change.key,
          quantity: change.quantity,
        });
      });
    }, Promise.resolve());
  }

  // Mirrors the theme cart JS: the drawer/cart empty-state CSS keys off
  // `is-empty` classes that section re-rendering alone doesn't update.
  function toggleEmptyState(itemCount) {
    var isEmpty = itemCount === 0;
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', isEmpty);
    var cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl) cartItemsEl.classList.toggle('is-empty', isEmpty);
    var cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);
  }

  // Re-renders the cart drawer / cart page / header bubble via the Section
  // Rendering API, mirroring how the theme's own cart JS updates them.
  function sectionsToRender() {
    var sections = [];
    if (document.querySelector('cart-drawer')) {
      sections.push({ name: 'cart-drawer', pick: '#CartDrawer', target: '#CartDrawer' });
    }
    var cartItems = document.getElementById('main-cart-items');
    if (cartItems && cartItems.dataset.id) {
      sections.push({ name: cartItems.dataset.id, pick: '.js-contents', target: '#main-cart-items .js-contents' });
    }
    var cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter && cartFooter.dataset.id) {
      sections.push({ name: cartFooter.dataset.id, pick: '.js-contents', target: '#main-cart-footer .js-contents' });
    }
    if (document.getElementById('cart-icon-bubble')) {
      sections.push({ name: 'cart-icon-bubble', pick: '.shopify-section', target: '#cart-icon-bubble' });
    }
    return sections;
  }

  function rerenderSections() {
    var sections = sectionsToRender();
    if (!sections.length) return Promise.resolve();

    var names = sections
      .map(function (s) {
        return s.name;
      })
      .join(',');

    // Render for the current page, like the theme's cart JS does, so template-specific
    // markup (the landing page's shipping banner) survives the re-render.
    return fetchJSON(window.location.pathname + '?sections=' + names).then(function (
      rendered
    ) {
      sections.forEach(function (section) {
        var target = document.querySelector(section.target);
        var html = rendered[section.name];
        if (!target || !html) return;
        var picked = new DOMParser().parseFromString(html, 'text/html').querySelector(section.pick);
        if (picked) target.innerHTML = picked.innerHTML;
      });

      // Replacing #CartDrawer's contents drops the overlay's close listener — rebind.
      var drawer = document.querySelector('cart-drawer');
      var overlay = drawer && drawer.querySelector('#CartDrawer-Overlay');
      if (drawer && overlay && typeof drawer.close === 'function') {
        overlay.addEventListener('click', drawer.close.bind(drawer));
      }
    });
  }

  function reconcile() {
    if (busy) {
      rerunRequested = true;
      return;
    }
    busy = true;

    fetchJSON('/cart.js')
      .then(function (cart) {
        var changes = planChanges(cart);
        if (!changes.length) return null;
        return applyChanges(changes)
          .then(function () {
            return fetchJSON('/cart.js');
          })
          .then(function (updatedCart) {
            toggleEmptyState(updatedCart.item_count);
            return rerenderSections();
          });
      })
      .catch(function (error) {
        console.error('[free-gift] reconcile failed', error);
      })
      .then(function () {
        busy = false;
        if (rerunRequested) {
          rerunRequested = false;
          reconcile();
        }
      });
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        reconcile();
      });
    }
    reconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
